<template>
  <div
    class="d-flex flex-row justify-content-center align-items-center flex-nowrap"
  >
    <slot></slot>
    <span
      v-if="locked"
      class="d-flex flex-row justify-content-center align-items-center lock-icon"
      v-tooltip="{
        content: iconTooltip,
        delay: 100,
        placement: 'top',
        container: 'body',
        trigger: 'click hover',
      }"
    >
      <i :class="iconClass"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'HMLock',
  props: {
    locked: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      default: 'fal fa-lock-alt',
    },
    iconTooltip: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.lock-icon {
  background-color: var(--brand-color, $coral);
  border-radius: 50%;
  color: white;
  font-size: 12px;
  width: 30px;
  min-width: 30px;
  height: 30px;
}
</style>
